import Day from "./Day";
import "./DayList.css";
import Bar from "./Bar";
import AddButton from "./AddButton";

function DayList({ date }) {
  const data = [
    ["밥약 1", "11시"],
    ["밥약 2", "11시"],
    ["밥약 3", "11시"],
    ["밥약 1", "13시"],
    ["밥약 2", "13시"],
    ["밥약 1", "15시"],
    ["밥약 1", "17시"],
  ];
  return (
    <div className="background">
      <div className="main">
        <h2>{date}</h2>

        <Day clock="11시" data={data}></Day>
        <Day clock="12시" data={data}></Day>
        <Day clock="13시" data={data}></Day>
        <Day clock="14시" data={data}></Day>
        <Day clock="15시" data={data}></Day>
        <Day clock="16시" data={data}></Day>
        <Day clock="17시" data={data}></Day>
        <Day clock="18시" data={data}></Day>
      </div>

      <div className="add">
        <AddButton text="Add"></AddButton>
      </div>

      <div className="nav-bar">
        <Bar></Bar>
      </div>
    </div>
  );
}

export default DayList;
